import { FunctionComponent } from 'react'
import { mapBulmaProps, BulmaProps, HTMLDivProps } from './base'

export interface ContainerProps extends HTMLDivProps, BulmaProps {}

export const Container: FunctionComponent<ContainerProps> = (props) => (
  <div {...mapBulmaProps(props, 'container')} />
)
